import { useEffect, useState } from 'react';
import { apiClient } from '@/api/client';

// ADMINSEC-3c-2b — fetches the public CAPTCHA config { siteKey, enabled } from the API
// (GET /api/v1/public/config — the customer-app mount of the same handler admin uses).
// Shared by the tenant + vendor login pages. On failure, reports disabled (login still
// works); if the server actually has CAPTCHA enabled the uniform guard rejects with
// CAPTCHA_REQUIRED, which the user resolves by retrying.

export interface CaptchaConfig {
  enabled: boolean;
  siteKey: string | null;
}

export function useCaptchaConfig(): CaptchaConfig {
  const [cfg, setCfg] = useState<CaptchaConfig>({ enabled: false, siteKey: null });

  useEffect(() => {
    let active = true;
    apiClient
      .get('/public/config')
      .then((res) => {
        if (!active) return;
        const d = (res.data?.data ?? {}) as { siteKey?: string | null; enabled?: boolean };
        setCfg({ enabled: !!d.enabled, siteKey: d.siteKey ?? null });
      })
      .catch(() => {
        if (active) setCfg({ enabled: false, siteKey: null });
      });
    return () => {
      active = false;
    };
  }, []);

  return cfg;
}
